<p (click)="infoReserveDismiss()">
  During your exit from the parking lot, scan the QR code above on the FastPass scanner. Your reservation rate will be applied to the amount due.
</p>